const STORAGE_KEY = 'usipanel.renderer.productDebugOpen';

const STAGE = (
  process.env.REACT_APP_APP_ENV
  || process.env.REACT_APP_ENV
  || ''
).toLowerCase();

const NON_PROD_HOST = /localhost|127\.0\.0\.1|recette|staging|\.dev\.|preprod/i;

/**
 * Debug sélection produit : dev + recette uniquement (pas prod).
 * Surcharge explicite : REACT_APP_PRODUCT_DEBUG=true|false
 */
export function isProductSelectionDebugAllowed() {
  const flag = process.env.REACT_APP_PRODUCT_DEBUG;
  if (flag === 'true') return true;
  if (flag === 'false') return false;

  if (process.env.NODE_ENV === 'development') return true;

  if (['dev', 'development', 'recette', 'staging', 'local', 'test'].includes(STAGE)) {
    return true;
  }

  if (typeof window !== 'undefined' && NON_PROD_HOST.test(window.location.hostname)) {
    return true;
  }

  return false;
}

/** @deprecated Utiliser isProductSelectionDebugAllowed() */
export const PRODUCT_SELECTION_DEBUG_ENABLED = isProductSelectionDebugAllowed();

export function readProductDebugPanelOpen() {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeProductDebugPanelOpen(open) {
  try {
    localStorage.setItem(STORAGE_KEY, open ? '1' : '0');
  } catch {
    /* ignore */
  }
}

/** Formule globale Pricing (fallback quand Products.priceFormula est vide). */
export const GLOBAL_PRICE_FORMULA_LINES = [
  '// SURFACE legacy (pas DXF m²)',
  'SURFACE = (X*Z + X*Y + SF1*Y*Z + SF2*X + SF3*Y + SF4*Z + SF5) / SF6',
  'prix_HT = PF1*SURFACE - PF2*SURFACE^PF3',
  'si BOTTOM: prix_HT *= 1.125',
  'prix_HT *= MATERIAL_FACTOR',
];

export const PRICE_FORMULA_POST_PROCESS = 'ceil(prix_HT × 1,20) + 24 € (TVA + port)';

/** Variables passées à evaluatePriceFormula côté backend (/price). */
export function buildPriceFormulaVars({
  sizeX,
  sizeY,
  sizeZ,
  installDims,
  surface,
  surfaceUnit,
  materialFactor,
}) {
  const d = installDims || {};
  return {
    X: Number(sizeX),
    Y: Number(sizeY),
    Z: Number(sizeZ),
    L: Number(d.L) || 0,
    H: Number(d.H) || 0,
    P1: Number(d.P1) || 0,
    P2: Number(d.P2) || 0,
    DEC: Number(d.DEC) || 0,
    DECi: d.DECi != null ? Number(d.DECi) : null,
    DECc: d.DECc != null ? Number(d.DECc) : null,
    SURFACE: surface != null ? Number(surface) : null,
    surfaceUnit: surfaceUnit ?? null,
    MATERIAL_FACTOR: materialFactor != null ? Number(materialFactor) : null,
    BOTTOM: !!d.BOTTOM,
    WALLMOUNT: !!d.WALLMOUNT,
    INSTALL: d.INSTALL ?? null,
  };
}

export const PRICE_FORMULA_VAR_LABELS = [
  ['SURFACE', 'Surface DXF (m²) ou legacy'],
  ['MATERIAL_FACTOR', 'Facteur matériau'],
  ['BOTTOM', 'Face dessous'],
  ['WALLMOUNT', 'Fixation murale'],
  ['INSTALL', "Type d'installation"],
];
